import { createContext, useContext } from "react";

import { WizardContextValue } from "./types";

/**
 * Context for Wizard state and methods
 */
export const WizardContext = createContext<WizardContextValue | null>(null);

/**
 * Hook to access wizard context
 * Must be used within a Wizard component
 *
 * @returns WizardContextValue
 * @throws Error if used outside of Wizard component
 */
export const useWizard = (): WizardContextValue => {
	const context = useContext(WizardContext);
	if (!context) {
		throw new Error("useWizard must be used within a Wizard component");
	}
	return context;
};
